import { theme } from '@evgo/react-material-components';
import styled from 'styled-components';

const {
  palette,
  shape: { borderRadius },
  spacing,
} = theme;

export const Styled = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  align-items: flex-start;
  align-self: stretch;
  margin: ${`${spacing(3)}px ${spacing(3) / 2}px 0`};
  border: 1px solid ${palette.text.disabled};
  border-radius: ${borderRadius}px;
  padding: ${`0 ${spacing(3) / 2}px ${spacing(3)}px`};

  > header {
    align-self: stretch;
    display: flex;
    align-content: flex-start;
    align-items: flex-start;
    margin: ${`${spacing(3)}px ${spacing(3) / 2}px 0`};

    > button {
      margin-left: auto;
    }

    > .form-control,
    > .select {
      flex-basis: 25%;
      margin: ${`0 ${spacing()}px -${spacing(2.5)}px`};
    }

    > :first-child {
      margin-left: 0;
    }

    > :last-child {
      margin-right: 0;
    }
  }

  > label {
    margin: ${`${spacing(2.5)}px ${spacing(3) / 2}px 0`};

    > span {
      padding: ${`0 ${spacing() / 2}px 0 0`};
    }
  }
`;
